import { render, staticRenderFns } from "./professionalServicesCom.vue?vue&type=template&id=1c82b4df&scoped=true&"
import script from "./professionalServicesCom.vue?vue&type=script&lang=js&"
export * from "./professionalServicesCom.vue?vue&type=script&lang=js&"
import style0 from "./professionalServicesCom.vue?vue&type=style&index=0&id=1c82b4df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c82b4df",
  null
  
)

export default component.exports